import cardValidator from 'card-validator';
import { validateEmail } from '../../Shared/validations';
import { copyFor } from '../../../copy/copy';
import { PaymentMethod } from '../../../utils/enums';

const validateFullName = values => {
    if (!values) return;
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName', 'email') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'email') };
};

const validateInternationalPostalCode = values => {
    if (!values) return;
    if (values.postalCode == null || values.postalCode === '') {
        return {postalCode: 'ZIP'};
    } else if (values.postalCode.length < 4) {
        return {postalCode: 'ZIP'};
    }
    return {};
};

const validateCard = values => {
    if (!values) return;
    const creditCardValidation = cardValidator.number(values.cardNumber);
    if (!creditCardValidation.isValid) {
        return { cardNumber: 'Card Number' };
    } else {
        if (
            creditCardValidation.card &&
            creditCardValidation.card.code &&
            creditCardValidation.card.code.size
        ) {
            const cvvValidation = cardValidator.cvv(
                values.cvv,
                creditCardValidation.card.code.size
            );

            if (!cvvValidation.isValid) {
                return { cvv: 'CVV' };
            }
        }
    }
    return {};
};

const validateCvv = values => {
    if (!values) return;
    const onlyNums = /^\d*$/;
    if (values.cvv == null || values.cvv === '' || onlyNums.exec(values.cvv) === false) {
        return { cvv: 'CVV' };
    }
    return {};
};

const validateDate = values => {
    if (!values) return;
    const dateValidation = cardValidator.expirationDate(values.expDate);
    if (!dateValidation.isValid) {
        return { expDate: 'MM/YY' };
    }
    return {};
};

const validation = (values, props) => {
    if (!values) return;
    let errors = {
        ...validateEmail(values),
        ...validateFullName(values)
    };
    if (props.paymentMethod === PaymentMethod.OrgHunter) {
        if (props.isStripeDataValid === false) errors.cardNumber = 'Card Number';
    }
    else {
        errors = {
            ...errors,
            ...validateInternationalPostalCode(values),
            ...validateDate(values),
            ...validateCard(values),
            ...validateCvv(values)
        };
    }

    return errors;
};

export default validation;
